<!--
    componente: toolbar-system
    propriedades: {
        sideIcon: recebe um boleano para habilitar o botão de chamada do menu de navegação
    }
-->
<template>
    <div>
        <v-navigation-drawer v-if="$route.path != '/'" v-model="drawer" clipped dark app>
            <progress-system :isLoad="system.progress"></progress-system>
            <v-list class="animated fadeIn" id="navegacao" v-if="isToken() && usuario != null && this.perfilUser().admin">
                <v-list-tile>
                    <v-list-tile-content>
                        Administrativo
                    </v-list-tile-content>
                </v-list-tile>
                <template v-for="item in drawerItemsAdmin">
                    <v-list-tile  :href="item.href" :key="item.index" ripple>
                        <v-list-tile-avatar>
                            <v-icon>mdi mdi-{{item.icon}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            {{item.title}}
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
            <v-divider></v-divider>
            <v-list class="animated fadeIn" id="navegacao" v-if="isToken() && usuario != null && this.perfilUser().professor">
                <v-list-tile>
                    <v-list-tile-content>
                        Professor
                    </v-list-tile-content>
                </v-list-tile>
                <template v-for="item in drawerItemsProfessor">
                    <v-list-tile  :href="item.href" :key="item.index" ripple>
                        <v-list-tile-avatar>
                            <v-icon>mdi mdi-{{item.icon}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            {{item.title}}
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
            <v-divider></v-divider>
            <v-list class="animated fadeIn" id="navegacao" v-if="isToken() && usuario != null && this.perfilUser().aluno">
                <v-list-tile>
                    <v-list-tile-content>
                        Aluno
                    </v-list-tile-content>
                </v-list-tile>
                <template v-for="item in drawerItemsAluno">
                    <v-list-tile :href="item.href" :key="item.index" ripple>
                        <v-list-tile-avatar>
                            <v-icon>mdi mdi-{{item.icon}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            {{item.title}}
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
            <v-divider></v-divider>
            <v-list class="animated fadeIn" id="navegacao" v-if="isToken() && usuario != null && this.perfilUser().datacom">
                <v-list-tile>
                    <v-list-tile-content>
                        Admin - DATACOM
                    </v-list-tile-content>
                </v-list-tile>
                <template v-for="item in drawerItemsDatacom">
                    <v-list-tile  :href="item.href" :key="item.index" ripple>
                        <v-list-tile-avatar>
                            <v-icon>mdi mdi-{{item.icon}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            {{item.title}}
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-navigation-drawer>

        <v-toolbar class="blue darken-1" clipped-left dark app>

            <v-toolbar-side-icon v-if="isToken() && usuario != null" @click="drawer = !drawer"></v-toolbar-side-icon>
            <v-avatar :tile="true">
                <v-img src="/img/logo/icon.png"></v-img>
            </v-avatar>
            <v-toolbar-title class="headline text-uppercase">
                <span class="font-weight-light">Escola da Assembleia</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn flat v-if="isToken() && usuario != null">{{usuario.Nome}}</v-btn>
            <v-toolbar-items v-if="$route.path == '/'">

                <v-btn v-for="item in socialButtons" :key="item.index" :href="item.href" target="_blank" :class="item.color" large dark icon>
                    <v-icon>mdi {{item.icon}}</v-icon>
                </v-btn>

            </v-toolbar-items>
            <v-menu offset-y transition="slide-y-transition" bottom v-if="isToken() && usuario != null">
                <template v-slot:activator="{ on }">
                    <v-avatar v-on="on">
                        <v-img class="avatar" :src="'https://sis.al.rn.dti.systems/sis/cliente/fotos/' + usuario.IdPessoaFisica + '.jpg'"></v-img>
                    </v-avatar>
                </template>
                <v-list width="700">
                    <v-list-tile href="/perfil">
                        <v-list-tile-action>
                            <v-icon>mdi mdi-card-account-details</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>Perfil</v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile @click="logOut()">
                        <v-list-tile-action>
                            <v-icon>mdi mdi-exit-to-app</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>Sair</v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>
    </div>
</template>
<script>
import ProgressSystem from './ProgressSystem'
import jwtDecode from 'jwt-decode'
export default {
    name: 'toolbar-system',
    components:{
      ProgressSystem
    },
    data () {
        return{
            drawer: null,
            system:{
              progress: true
            },
            drawerItemsAdmin: [
                //{title: 'Dashboard', href: '/admin', icon: 'view-dashboard'},
                //{title: 'Avisos', href: '/admin/avisos', icon: 'message-bulleted'},
                {title: 'Parceiros', href: '/admin/parceiros', icon: 'account-group'},
                {title: 'Enviar notificações', href: '/admin/notificacoes', icon: 'bell-ring'},
                {title: 'Log de notificações de turma', href:'/admin/notificacoesturma', icon: 'bell-ring'},
                {title: 'Fórum', href: '/admin/foruns', icon: 'forum'},
                {title: 'Feedbacks', href: '/admin/faleconoscos', icon: 'comment'}
            ],
            drawerItemsDatacom: [
                //{title: 'Dashboard', href: '/admin', icon: 'view-dashboard'},
                //{title: 'Avisos', href: '/admin/avisos', icon: 'message-bulleted'},
                {title: 'Parceiros', href: '/admin/parceiros', icon: 'account-group'},
                {title: 'Enviar notificações', href: '/admin/notificacoes', icon: 'bell-ring'},
                {title: 'Log de notificações de turma', href:'/admin/notificacoesturma', icon: 'bell-ring'},
                {title: 'Fórum', href: '/admin/foruns', icon: 'forum'},
                {title: 'Feedbacks', href: '/admin/faleconoscos', icon: 'comment'},
                {title: 'Manutenção', href: '/admin/manutencao', icon: 'server-network-off'}
            ],
            drawerItemsAluno: [
                {title: 'Programação acadêmica', href: '/aluno/programacao_academica', icon: 'calendar-multiselect'},
                {title: 'Meus cursos', href: '/aluno/meus_cursos', icon: 'school'},
                {title: 'Fale conosco', href: '/aluno/faleconoscos', icon: 'comment'},
            ],
            drawerItemsProfessor: [
                //{title: 'Avisos', href: '/admin/avisos', icon: 'message-bulleted'},
                {title: 'Notificações', href: '/admin/notificacoes', icon: 'bell-ring'},
                {title: 'Fórum', href: '/admin/foruns', icon: 'forum'}
            ],
            socialButtons:[
              {icon:'mdi-whatsapp', href:'whatsapp://send?text=Acompanhe%20as%20noticias%20da%20Assembleia: http%3A%2F%2www.al.rn.gov.br', color:'green darken-2'},
              {icon:'mdi-twitter', href:'https://twitter.com/AssembleiaRN', color:'light-blue lighten-1'},
              {icon:'mdi-youtube', href:'https://www.youtube.com/user/assecomalrn', color:'red draken-1'},
              {icon:'mdi-facebook', href:'https://www.facebook.com/AssembleiaRN/', color:'blue darken-4'},
              {icon:'mdi-instagram', href:'https://www.instagram.com/AssembleiaRN/', color:'blue-grey darken-1'},
            ],
            usuario: null
        }
    },
    methods: {

        //pegando informações do usuário logado para colocar na barra
        getDadosUsuario (){
            if(this.$route.path != '/'){
                this.axios.get('user').then(res => {
                    this.usuario = res.data
                }).catch(e => {
                    if(e.response.status == 401){
                        localStorage.clear()
                        location.href = "/"
                    }
                }).finally(() => {
                  this.system.progress = false
                })
            }
        },
        logOut(){
            localStorage.clear()
            location.href = "/"
        },
        //Verifica se o usuário já tem um token para manipular a exibição de componentes na tela
        isToken () {
            let token = localStorage.getItem('token')
            if(token == null || token == ""){
                return false
            }else{
                return true
            }
        },
        perfilUser(){
          return jwtDecode(localStorage.getItem('token'))
        }
    },
    mounted(){
        this.getDadosUsuario()
    }
}
</script>
<style>
    .avatar{
        border: solid 1.5px #ffffff;
    }
</style>
